
import Vue from 'vue';
import pkg from '../package.json';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', { attrs: { id: 'app' } }, [
    _c('main', { attrs: { role: 'main' } }, [_c('router-view')], 1),
  ]);
};
var staticRenderFns = [];

export default Vue.extend({
  render,
  staticRenderFns,
  data: () => ({
    date: new Date().getFullYear(),
  }),
  metaInfo: {
    meta: [
      { charset: 'utf-8' },
      { httpEquiv: 'X-UA-Compatible', content: 'IE=edge' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1, shrink-to-fit=no' },
      { name: 'version', content: process.env.VUE_APP_VERSION },
    ],
    link: [{ rel: 'icon', href: `${process.env.BASE_URL}favicon.ico` }],
    titleTemplate: (chunk) => (chunk ? `${chunk} | ${pkg.description}` : pkg.description),
  },
});
